import { NewsCategory } from "../types/news";

export const CATEGORIES: NewsCategory[] = [
  { id: "all", label: "Top Stories" },
  { id: "market", label: "Markets" },
  { id: "economy", label: "Economy" },
  { id: "technology", label: "Technology" },
  { id: "ipo", label: "IPO & Bonds" },
];

export const ITEMS_PER_PAGE = 12;

// Dummy content generator
